<template>
  <div class="bg-white margin-top-xs padding border-radius">
    <div class="mb-10">
      <el-button size="small" type="text" @click="openAddModal">
        添加
      </el-button>
      <el-button size="small" type="text" @click="openEditModal">
        修改
      </el-button>
      <el-button size="small" type="text" @click="openDeleteModal">
        删除
      </el-button>
    </div>
    <div class="vc-org margin-top">
      <ul>
        <li v-for="(role, index) in roleDivInfo.roles" :key="index" @click="switchRole(role)"
          :class="{ 'active': role.pgId == roleDivInfo.curRole.pgId }">
          {{ role.name }}
        </li>
      </ul>
    </div>

    <add-privilege-group ref="addPrivilegeGroup" @refresh="loadRoles()"></add-privilege-group>
    <edit-privilege-group ref="editPrivilegeGroup" @refresh="loadRoles()"></edit-privilege-group>
    <delete-privilege-group ref="deletePrivilegeGroup" @refresh="loadRoles()"></delete-privilege-group>
  </div>
</template>

<script>
import AddPrivilegeGroup from '@/components/dev/addPrivilegeGroup/addPrivilegeGroup'
import EditPrivilegeGroup from '@/components/dev/editPrivilegeGroup/editPrivilegeGroup'
import DeletePrivilegeGroup from '@/components/dev/deletePrivilegeGroup/deletePrivilegeGroup'
import { getShopId } from '@/api/shop/shopApi'
import { getPrivilegeGroupList } from '@/api/frame/roleApi'

export default {
  name: 'RoleDiv',
  components: {
    AddPrivilegeGroup,
    EditPrivilegeGroup,
    DeletePrivilegeGroup
  },
  data() {
    return {
      roleDivInfo: {
        roles: [],
        curRole: {}
      }
    }
  },
  created() {
    this.loadRoles()
  },
  methods: {
    async loadRoles() {
      try {
        const params = {
          shopId: getShopId()
        }
        const res = await getPrivilegeGroupList(params)
        this.roleDivInfo.roles = res
        if (res && res.length > 0) {
          this.switchRole(res[0])
        }
      } catch (error) {
        console.error('获取角色列表失败:', error)
      }
    },
    switchRole(role) {
      this.roleDivInfo.curRole = role
      this.$emit('switchRole', role)
    },
    openAddModal() {
      this.$refs.addPrivilegeGroup.open()
    },
    openEditModal() {
      if (!this.roleDivInfo.curRole.pgId) {
        this.$message.warning('请先选择角色')
        return
      }
      this.$refs.editPrivilegeGroup.open(this.roleDivInfo.curRole)
    },
    openDeleteModal() {
      if (!this.roleDivInfo.curRole.pgId) {
        this.$message.warning('请先选择角色')
        return
      }
      this.$refs.deletePrivilegeGroup.open(this.roleDivInfo.curRole)
    }
  }
}
</script>

<style scoped>
.bg-white {
  background: #fff;
}

.margin-top-xs {
  margin-top: 10px;
}

.padding {
  padding: 15px;
}

.border-radius {
  border-radius: 4px;
}

.vc-org ul {
  list-style: none;
  padding: 0;
}

.vc-org li {
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.vc-org li:hover {
  background: #f5f5f5;
}

.vc-org li.active {
  background: #409EFF;
  color: #fff;
}

.margin-top {
  margin-top: 15px;
}

.mb-10 {
  margin-bottom: 10px;
}
</style>